import { Agency } from "@adgate/common/types/agency.type";
import { CommercialOffice } from "@adgate/common/types/commercial-office.type";
import { Status } from "@adgate/common/types/status.type";

export class CampaignFilter
{
    brand!: string;
    number!: string;
    title!: string;
    agency: Agency[];
    commercialOffice: CommercialOffice[];
    status: Status[];
    createdFrom!: number | null;
    createdTo!: number | null;
    limit!: number;

    constructor()
    {
        this.agency = [];
        this.commercialOffice = [];
        this.status = [];
        this.limit = 100;
    }
}